import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { splitLatexSegments } from '../../utils/splitLatexText';

function renderKatex(tex, displayMode) {
  const trimmed = String(tex).trim();
  if (!trimmed) {
    return '';
  }
  try {
    return katex.renderToString(trimmed, {
      displayMode,
      throwOnError: false,
      strict: 'ignore',
    });
  } catch {
    return katex.renderToString(trimmed, {
      displayMode,
      throwOnError: false,
      strict: 'ignore',
    });
  }
}

/**
 * Renders plain text with optional inline ($...$) and display ($$...$$) LaTeX.
 */
const LatexMixedText = ({ text = '', className, style, block }) => {
  const segments = splitLatexSegments(text == null ? '' : String(text));
  const Wrapper = block ? 'div' : 'span';
  return (
    <Wrapper className={className} style={style}>
      {segments.map((seg, i) => {
        if (seg.t === 'text') {
          return (
            <span key={i} style={{ whiteSpace: 'pre-wrap' }}>
              {seg.v}
            </span>
          );
        }
        if (seg.t === 'inline') {
          return (
            <span
              key={i}
              dangerouslySetInnerHTML={{
                __html: renderKatex(seg.v, false),
              }}
            />
          );
        }
        return (
          <span
            key={i}
            style={{
              display: 'block',
              margin: '0.35em 0',
              textAlign: 'center',
              overflowX: 'auto',
            }}
            dangerouslySetInnerHTML={{
              __html: renderKatex(seg.v, true),
            }}
          />
        );
      })}
    </Wrapper>
  );
};

export default LatexMixedText;
